import MultiselectNestedDropdown from "@app/shared/checkbox-dropdown/MultiselectNestedDropdown";
import { DropdownItem, NestingParentDropdownItem } from "@app/shared/checkbox-dropdown/types";
import { JSX } from "react";

interface NetworkIntegrityServiceAreaFilterProps {
  disabled?: boolean;
  filters?: { key: string; displayValue: string }[];
  items: NestingParentDropdownItem[];
  matchFilter?: (child: DropdownItem<string>, activeKeys: string[]) => boolean;
  onSelectedFiltersChange?: (keys: string[]) => void;
  onSelectionChanged: (selectedItems: string[]) => void;
  selectedFilters?: string[];
  selectedItems: string[];
  selectionText: string;
}

const NetworkIntegrityServiceAreaFilter = (props: NetworkIntegrityServiceAreaFilterProps): JSX.Element => {
  const {
    disabled,
    filters,
    items,
    matchFilter,
    onSelectedFiltersChange,
    onSelectionChanged,
    selectedFilters,
    selectedItems,
    selectionText,
  } = props;

  return (
    <MultiselectNestedDropdown
      containerClassName="item-column"
      customSelectInputText={selectionText}
      disabled={disabled}
      filters={filters}
      items={items}
      label="Service Area:"
      matchFilter={matchFilter}
      onSelectedFiltersChange={onSelectedFiltersChange}
      onSelectionChanged={onSelectionChanged}
      selectedFilters={selectedFilters}
      selectedItems={selectedItems}
      testId="network-integrity-filters__service-area"
    />
  );
};

export default NetworkIntegrityServiceAreaFilter;
